import type { PropsWithChildren, ReactNode } from "react";
import { Provider } from "@/components/ui/provider";
import { Flex, Box } from "@chakra-ui/react";

const DefaultLayout = ({ children }: PropsWithChildren): ReactNode => (
  <Provider forcedTheme="light">
    <Flex minH="100vh">
      <Box as="main" flex="1">
        {children}
      </Box>
    </Flex>
  </Provider>
);

export default DefaultLayout;
